import { tCaseCategories } from '@/Interfaces/caseCategories';

export const caseCategories: tCaseCategories = [
    {
        id: '1b4e5141-bd5f-4736-8a91-8f9c53449580',
        name: 'Серия TC',
        description: 'Предназначены для хранения легких и средней тяжести предметов',
        caseType: 'light',
        image: 'dist/src/img/tc.webp',
    },
    {
        id: 'b391fb8e-d0c0-4549-978d-fa37650d0298',
        name: 'Серия АМН TC',
        description: 'Предназначены для хранения инструментов, оснастки, тяжелых грузов',
        caseType: 'medium',
        image: 'dist/src/img/amh_tc.webp',
    },
    {
        id: 'f5020fc9-0e74-44b9-91c5-6470f3012636',
        name: 'Серия HARD',
        description: 'Предназначены для хранения инструментов, оснастки, тяжелых грузов',
        caseType: 'heavy',
        image: 'dist/src/img/hard.webp',
    },
];
